import React, {useState, useEffect} from 'react';
import {useSelector} from "react-redux";
import { useTranslation } from "react-i18next";

const PdfFooter = () => {
    const [data, setData] = useState(null);
// https://clay.powdev.lt/module/revisualizer/modules/revisualizer/src/app/assets/json/pdf-footer.json
// const saveButton = process.env.PUBLIC_URL + assetsPath + 'images/save-button.svg';
    const assetsPath = useSelector(state => state.Feature.assetsPath);
    useEffect(() => {
        fetch(process.env.PUBLIC_URL + assetsPath + 'json/pdf-footer.json') // refers to public/data.json
        .then((response) => {
            if (!response.ok) {
            throw new Error('Failed to fetch data.json');
            }
            return response.json();
        })
        .then((json) => setData(json))
        .catch((error) => console.error('Error loading JSON:', error));
    }, [assetsPath]);
  
  const { t } = useTranslation();
  
  return(
    <>
        <div className="pdf-footer-bound"></div>
        <div className='pdf-footer-title'>{t('Requisites')}:</div>
        <div>
            {/* {JSON.stringify( data)} */}
            {data && (
                <table className='pdf-footer'>
                    <tr>
                        <td>
                            <div className='pdf-footer-contact-info-phone'>
                                <svg  xmlns="http://www.w3.org/2000/svg"  width="14"  height="14"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  strokeWidth="2"  strokeLinecap="round"  strokeLinejoin="round"  className="icon icon-tabler icons-tabler-outline icon-tabler-phone"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2" /></svg>
                                <span>{data.column1.phone}</span>
                            </div>
                            <div className='pdf-footer-contact-info-email'>
                                <svg  xmlns="http://www.w3.org/2000/svg"  width="14"  height="14"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  strokeWidth="2"  strokeLinecap="round"  strokeLinejoin="round"  className="icon icon-tabler icons-tabler-outline icon-tabler-mail"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M3 7a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-10z" /><path d="M3 7l9 6l9 -6" /></svg>
                                <span>{data.column1.email}</span>
                            </div>
                        </td>
                        <td>
                            <div>
                                {data.column2.map((item, index) => (
                                    <React.Fragment key={index}>
                                        {item}
                                        <br />
                                    </React.Fragment>
                                ))}
                            </div> 
                        </td>
                        <td>
                            <div>
                                {data.column3.map((item, index) => (
                                    <React.Fragment key={index}>
                                        {item}
                                        <br />
                                    </React.Fragment>
                                ))}
                            </div>
                        </td>
                    </tr>
                </table>
            )}
        </div>
    </>
  )
}

export default PdfFooter;